'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var dataRow = require('./data-row-61a2fbf3.js');
var loadingRow = require('./loading-row-c6ac4f15.js');

var ContentRow = function (_a) {
    var dataCy = _a.dataCy, dataTestId = _a.dataTestId, columns = _a.columns, rowIndex = _a.rowIndex, row = _a.row, _b = _a.nestingLevel, nestingLevel = _b === void 0 ? 0 : _b, _c = _a.parents, parents = _c === void 0 ? [] : _c, onToggleRow = _a.onToggleRow, isLastRow = _a.isLastRow;
    var hasParents = parents.length > 0;
    var isLastLeaf = !row.childRowsExpanded && isLastRow && hasParents;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(dataRow.DataRow, { row: row, columns: columns, rowIndex: rowIndex, nestingLevel: nestingLevel, parents: parents, onToggleRow: onToggleRow, dataCy: dataCy, dataTestId: dataTestId, isLastLeaf: isLastLeaf }),
        React__default.createElement(loadingRow.LoadingRow, { colSpan: columns.length, row: row, dataCy: dataCy, dataTestId: dataTestId }),
        row.childRowsExpanded && (React__default.createElement(TableRows, { rows: row.childRows, columns: columns, dataCy: dataCy, dataTestId: dataTestId, onToggleRow: onToggleRow, nestingLevel: nestingLevel + 1, parents: tslib_es6.__spread(parents, [row]) }))));
};

// eslint-disable-next-line import/no-cycle
var TableRows = function (_a) {
    var dataCy = _a.dataCy, dataTestId = _a.dataTestId, columns = _a.columns, rows = _a.rows, nestingLevel = _a.nestingLevel, _b = _a.parents, parents = _b === void 0 ? [] : _b, onToggleRow = _a.onToggleRow;
    return (React__default.createElement(React__default.Fragment, null, rows === null || rows === void 0 ? void 0 : rows.map(function (row, index) { return (React__default.createElement(ContentRow, { key: "row-" + index, row: row, columns: columns !== null && columns !== void 0 ? columns : [], rowIndex: index, dataCy: dataCy, dataTestId: dataTestId, onToggleRow: onToggleRow, nestingLevel: nestingLevel, parents: parents, isLastRow: index === rows.length - 1 })); })));
};

exports.ContentRow = ContentRow;
exports.TableRows = TableRows;
